import { RequestConstants } from "../../../../core/request/RequestConstants";
import { WebRequest } from "../../../../core/request/WebRequest";
import { SetSettingsResponseData } from "../response/data/SetSettingsResponseData";
/**
 * SetSettingsRequest.ts
 */
export class SetSettingsRequest extends WebRequest {
    constructor(params) {
        super(SetSettingsRequest.URL, params);
    }
    getMethod() {
        return RequestConstants.POST;
    }
    getDataClass() {
        return SetSettingsResponseData;
    }
}
SetSettingsRequest.URL = "/responsible-gaming/api/setSettings";
//# sourceMappingURL=SetSettingsRequest.js.map